// Button.js — the v3 action primitive.
// variant: 'primary' (solid cobalt — ONE per view) | 'secondary' (hairline) |
//          'ghost' (borderless) | 'dark' (navy). size: 'sm'|'md'|'lg'.
// Hover tints the background; no scale on press; press darkens cobalt → inkSoft
// (handled by callers/CSS where needed). Faithful port of components/core/Button.jsx,
// extended with an onMouseEnter/Leave hover tint that respects the no-scale rule.
import React, { useState } from 'react';
import { v3 } from '../../lib/styleTokens';

const VARIANTS = {
  primary:   { bg: v3.color.ink,   fg: '#FFFFFF',       border: v3.color.ink,   hover: v3.color.inkSoft },
  secondary: { bg: v3.color.card,  fg: v3.color.body,   border: v3.color.border, hover: v3.color.cardAlt },
  ghost:     { bg: 'transparent',  fg: v3.color.bodySoft, border: 'transparent', hover: v3.color.cardAlt },
  dark:      { bg: v3.color.navy,  fg: '#FFFFFF',       border: v3.color.navy,  hover: v3.color.navy },
};

const SIZES = {
  sm: { pad: '6px 12px',  font: v3.font.size.small },
  md: { pad: '9px 16px',  font: v3.font.size.label },
  lg: { pad: '12px 20px', font: v3.font.size.body },
};

export function Button({ variant = 'secondary', size = 'md', icon, children, onClick, disabled, type = 'button', style = {}, ...rest }) {
  const v = VARIANTS[variant] || VARIANTS.secondary;
  const s = SIZES[size] || SIZES.md;
  const [hover, setHover] = useState(false);
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: s.pad,
        borderRadius: v3.radius.input,
        background: !disabled && hover ? v.hover : v.bg,
        color: v.fg,
        border: `1px solid ${v.border}`,
        fontFamily: v3.font.family,
        fontSize: s.font,
        fontWeight: v3.font.weight.semibold,
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        whiteSpace: 'nowrap',
        transition: 'background 140ms ease-out',
        ...style,
      }}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}
